import React from 'react';
import PropTypes from 'prop-types';
import { FILTER_IDS } from '@src/js/constants';
import { SearchFilter } from '@src/components/core/core-component-imports';
import SearchResultsPageContentType from '@js/content-types/search-results-page-content-type.es6';

/**
 * Renders a global-level search filter for content type categories.
 */
const PageCategoryFilter = ({
  open,
  clickHandler,
  selectionHandler,
  allResultsCount,
  conditionResultsCount,
  leadershipResultsCount,
  locationResultsCount,
  providerResultsCount,
  researchResultsCount,
  serviceResultsCount,
  specialtyResultsCount,
  treatmentResultsCount,
  blogResultsCount,
}) => {
  const searchResultsPage = new SearchResultsPageContentType();
  const categoryFilterLabel = searchResultsPage.filterByCategoryLabel.item.$(0).text();
  const applyFilterLabel = searchResultsPage.applyFilterLabel.item.$(0).text();
  const clearLabel = searchResultsPage.clearLabel.item.$(0).text();
  const searchPlaceholder = searchResultsPage.searchPlaceholder.item.$(0).text();
  const allResultsLabel = searchResultsPage.allResultsFilterLabel.item.$(0).text();
  const conditionLabel = searchResultsPage.conditionFilterLabel.item.$(0).text();
  const leadershipLabel = searchResultsPage.leadershipFilterLabel.item.$(0).text();
  const locationLabel = searchResultsPage.locationFilterLabel.item.$(0).text();
  const providerLabel = searchResultsPage.providerFilterLabel.item.$(0).text();
  const researchLabel = searchResultsPage.researchFilterLabel.item.$(0).text();
  const serviceLabel = searchResultsPage.serviceFilterLabel.item.$(0).text();
  const specialtyLabel = searchResultsPage.specialtyFilterLabel.item.$(0).text();
  const treatmentLabel = searchResultsPage.treatmentFilterLabel.item.$(0).text();
  const blogLabel = searchResultsPage.blogFilterLabel.item.$(0).text();

  const options = {
    [FILTER_IDS.ALL_RESULTS]: {
      label: `${allResultsLabel} (${allResultsCount})`,
      disabled: (allResultsCount === 0),
    },
    [FILTER_IDS.CONDITION]: {
      label: `${conditionLabel} (${conditionResultsCount})`,
      disabled: (conditionResultsCount === 0),
    },
    [FILTER_IDS.LEADERSHIP]: {
      label: `${leadershipLabel} (${leadershipResultsCount})`,
      disabled: (leadershipResultsCount === 0),
    },
    [FILTER_IDS.LOCATION]: {
      label: `${locationLabel} (${locationResultsCount})`,
      disabled: (locationResultsCount === 0),
    },
    [FILTER_IDS.PROVIDER]: {
      label: `${providerLabel} (${providerResultsCount})`,
      disabled: (providerResultsCount === 0),
    },
    [FILTER_IDS.RESEARCH]: {
      label: `${researchLabel} (${researchResultsCount})`,
      disabled: (researchResultsCount === 0),
    },
    [FILTER_IDS.SERVICE]: {
      label: `${serviceLabel} (${serviceResultsCount})`,
      disabled: (serviceResultsCount === 0),
    },
    [FILTER_IDS.SPECIALTY]: {
      label: `${specialtyLabel} (${specialtyResultsCount})`,
      disabled: (specialtyResultsCount === 0),
    },
    [FILTER_IDS.TREATMENT]: {
      label: `${treatmentLabel} (${treatmentResultsCount})`,
      disabled: (treatmentResultsCount === 0),
    },
    [FILTER_IDS.BLOG]: {
      label: `${blogLabel} (${blogResultsCount})`,
      disabled: (blogResultsCount === 0),
    }
  };

  return (
    <SearchFilter
      name={categoryFilterLabel}
      queryParameterName={FILTER_IDS.CATEGORY}
      options={options}
      defaultOptionId={FILTER_IDS.ALL_RESULTS}
      open={open}
      clickHandler={clickHandler}
      selectionHandler={selectionHandler}
      applyFilterLabel={applyFilterLabel}
      clearLabel={clearLabel}
      allowSearch={false}
      searchPlaceholder={searchPlaceholder}
    />
  );
}

PageCategoryFilter.propTypes = {
  /**
   *  determines if the filter is active for user selection (when true) or closed (when false)
   */
  open: PropTypes.bool.isRequired,
  /**
   * the callback function for when the filter button is clicked
   */
  clickHandler: PropTypes.func.isRequired,
  /**
   * the callback function for when a selection is made
   */
  selectionHandler: PropTypes.func.isRequired,
  /**
   * the total number of results
   */
  allResultsCount: PropTypes.number.isRequired,
  /**
   * the number of condition results
   */
  conditionResultsCount: PropTypes.number.isRequired,
  /**
   * the number of leadership results
   */
  leadershipResultsCount: PropTypes.number.isRequired,
  /**
   * the number of location results
   */
  locationResultsCount: PropTypes.number.isRequired,
  /**
   * the number of provider results
   */
  providerResultsCount: PropTypes.number.isRequired,
  /**
   * the number of research results
   */
  researchResultsCount: PropTypes.number.isRequired,
  /**
   * the number of service results
   */
  serviceResultsCount: PropTypes.number.isRequired,
  /**
   * the number of specialty results
   */
  specialtyResultsCount: PropTypes.number.isRequired,
  /**
   * the number of treatment results
   */
  treatmentResultsCount: PropTypes.number.isRequired,
};

export default PageCategoryFilter;
